export enum EventType {
  LOGIN_DEVICE_LIMIT = 'login-device-limit',
  BIND_DEVICE_LIMIT = 'bind-device-limit',
}
